import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";
import React from "react";
import FadeInSection from "./FadeInSection";

const isHorizontal = window.innerWidth < 600;

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  if (isHorizontal) {
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  } else {
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`vertical-tabpanel`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
};

function a11yProps(index) {
  if (isHorizontal) {
    return {
      id: `full-width-tab-${index}`,
      "aria-controls": `full-width-tabpanel-${index}`
    };
  } else {
    return {
      id: `vertical-tab-${index}`
    };
  }
}

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: "theme.palette.background.paper",
    display: "flex",
    height: 300
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`
  }
}));

const JobList = () => {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const experienceItems = {
    
    "EVA Team": {
      jobTitle: "AI Engineer @",
      duration: "JAN 2024 - SEPT 2024",
      desc: [
        "Developed an AI-driven algorithm leveraging Recurrent Neural Networks (RNNs) to influence health-related decisions, such as vaccination, surgery, and medical treatments, based on survey data.",
        "Analyzed hesitancies and identified key factors impacting decision-making, using advanced data modeling techniques to derive actionable insights.",
        "Presented research findings and results to the academic team, ensuring alignment with project objectives and continuous improvement in algorithm accuracy.",
        "Relevant technologies/tools used: Python, TensorFlow, Pandas, NumPy, survey data preprocessing methods, and advanced statistical analysis."
      ]
    },
    "Gile Interior": {
      jobTitle: "Software Developer Intern@",
      duration: "Jul 2023 - Dec 2023",
      desc: [
        "Developed a mobile application using React Native, integrating user authentication and database management with PHP and MySQL.",
        "Co-developed an e-commerce website, implementing dynamic product catalogues and payment processing functionalities using React, Node.js, and MySQL.",
        "Collaborated with the design team to ensure user-friendly interfaces and optimized application performance."

      ]
    },
    "Defne Telecommunication": {
      jobTitle: "Software Developer Intern @",
      duration: "FEB 2023 - MAR 2023",
      desc: [
        "Developed a feature-rich website backend using Spring Boot, focusing on robust API development and database management.",
        "Created an interactive and responsive front-end with React, ensuring a seamless user experience.",
        "Participated in team sprints, contributing to code reviews and resolving critical bugs to meet project deadlines."
      ]
    }
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <Tabs
        orientation={!isHorizontal ? "vertical" : null}
        variant={isHorizontal ? "fullWidth" : "scrollable"}
        value={value}
        onChange={handleChange}
        className={classes.tabs}
      >
        {Object.keys(experienceItems).map((key, i) => (
          <Tab label={isHorizontal ? `0${i}.` : key} {...a11yProps(i)} />
        ))}
      </Tabs>
      {Object.keys(experienceItems).map((key, i) => (
        <TabPanel value={value} index={i}>
          <span className="joblist-job-title">
            {experienceItems[key]["jobTitle"] + " "}
          </span>
          <span className="joblist-job-company">{key}</span>
          <div className="joblist-duration">
            {experienceItems[key]["duration"]}
          </div>
          <ul className="job-description">
            {experienceItems[key]["desc"].map(function (descItem, i) {
              return (
                <FadeInSection delay={`${i + 1}00ms`}>
                  <li key={i}>{descItem}</li>
                </FadeInSection>
              );
            })}
          </ul>
        </TabPanel>
      ))}
    </div>
  );
};

export default JobList;
